import { render, staticRenderFns } from "./Explanation.vue?vue&type=template&id=8d3cde24&scoped=true"
import script from "./Explanation.vue?vue&type=script&lang=js"
export * from "./Explanation.vue?vue&type=script&lang=js"
import style0 from "./Explanation.vue?vue&type=style&index=0&id=8d3cde24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d3cde24",
  null
  
)

export default component.exports